// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__25udK","dragIcon":"Choice_dragIcon__2tex6","left":"Choice_left__1jzCk","input":"Choice_input__1RLLo"};